import React, { useEffect, useRef, useState } from 'react';
import styles from './step0.module.scss';
import classNames from 'classnames';
import FormBuilder from 'components/form/builder/builder';
import StateDropdown from 'components/form/stateDropdown/stateDropdown';
import * as Constants from '../constants';
import * as Yup from 'yup';

const Step0 = props => {

  const state = sessionStorage.getItem('state');
  const license = sessionStorage.getItem('license');
  const fein = sessionStorage.getItem('fein');

  const initialValues = {
    AgentLicense: license || '',
    State: state || '',
    FEIN: fein || '',
    ...props.values
  };

  const childRef = useRef(null);


  useEffect(() => {
    setTimeout(() => {
      if ((state && license) || fein) {
        childRef.current.submitForm();
        sessionStorage.removeItem('state');
        sessionStorage.removeItem('license');
        sessionStorage.removeItem('fein');
      }
    }, 1000)
  }, [fein, license, state])

  const schemaShape = {
    AgentLicense: Yup.string()
      .trim()
      .matches(/^[0-9A-Za-z-]{1,10}$/, {
        message:
          'Invalid license number.  Should be less than 10 characters. Only letters and numbers allowed.'
      })
      .test('validateAgentLicense', 'Must enter a valid Agent License and State or FEIN number',
        function (value) {
          const { parent } = this;
          let isValid = true;

          if (!parent.FEIN) {
            isValid = typeof value !== 'undefined';
          }
          setButtonDisabledAttribute(parent)
          return isValid;
        }
      ),
    State: Yup.string()
      .trim()
      .matches(/^[A-Za-z]{1,4}$/, {
        message:
          'Invalid state.  Should be less than 4 characters. Only letters allowed.'
      })
      .test('validateState', 'Must enter a valid Agent License and State or FEIN number',
        function (value) {
          const { parent } = this;
          let isValid = true;

          if (!parent.FEIN) {
            isValid = typeof value !== 'undefined';
          }
          setButtonDisabledAttribute(parent)
          return isValid;
        }),
    FEIN: Yup.string()
      .trim()
      .matches(Constants.DIGITS_ONLY, {
        message: 'FEIN should consist only of digits (0-9).'
      })
      .matches(/^[0-9]{9}$/, {
        message: 'FEIN/TIN should be 9 digit long.'
      })
      .test('validateFEIN', 'Must enter a valid Agent License and State or FEIN number',
        function (value) {
          const { parent } = this;
          let isValid = true;
          setButtonDisabledAttribute(parent);
          if (!parent.AgentLicense && !parent.State) {
            isValid = typeof value !== 'undefined';
          }
          return isValid;
        }
      ),
  };
  function setButtonDisabledAttribute(parent) {
    setButtonDisabled(true);
    if ((parent.AgentLicense && parent.State) || (parent.FEIN)) {
      setButtonDisabled(false)
    }
  }
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const elements = [
    {
      placeholder: 'Enter License Number',
      name: 'AgentLicense',
      mapped: true,
      maxLength: 20
    },
    {
      name: 'State',
      Component: StateDropdown,
      col: '4'
    },
    {
      name: 'labelContainer',
      label: '- OR -',
      labelOnly: true,
    },
    {
      placeholder: 'Enter FEIN Number',
      name: 'FEIN',
      mapped: true,
      maxLength: 20
    },
  ]

  return (
    <section className={classNames(styles.wrapper)}>
      <div className="container">
        <div className="row">

          <div className={classNames("col-lg-6", styles["text-body"])}>
            <p>
              We are thrilled that you have decided to make the leap with BTIS!
              We're here to make sure you have everything you need to be
              successful in writing business with us. The registration process
              is super simple, just a few questions to get to know you (and your
              business) and you're on your way!
            </p>
            <p>
              Before you jump into getting registered, please be sure to have
              the following on-hand:
            </p>
            <ul className={classNames(styles['required-documents'])}>
              <li>Business Tax ID Number</li>
              <li>E&amp;O Documents</li>
              <li>Agency License</li>
            </ul>

          </div>
          <div className="col-lg-6 py-5">
            
            <p className={classNames(styles['paragraph'],"mx-5")}><strong>Please enter your Agent License# and state or FEIN to get started</strong></p>
            <FormBuilder
              elements={elements}
              initialValues={initialValues}
              isSubmitButtonDisabled={buttonDisabled}
              loading={props.loading}
              onNext={props.onNext}
              schemaShape={schemaShape}
              updateValues={props.updateValues}
              step={props.step}
              setStep={props.setStep}
              ref={childRef}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Step0;